import React, { useContext, useState } from "react";
import "./Header.css";
import { Button, Modal, Nav, Navbar } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import Fire_Lottie from "../animation/fire_lottie/Fire_Lottie";
import Profile from "../common_components/profile/Profile";
import { Context } from "../../utils/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faBell,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { logoutUser } from "../../features/admin/auth/Slice";
import { useDispatch } from "react-redux";
import SuccessModal from "../common_components/common_modal/profile_succes_modal/ProfileSucces";
import WhiteButton from "../common_components/common_button/WhiteButton";

function Header() {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const dispatch = useDispatch();
  return (
    <>
      <header className="header-background">
        <div className="container custom-nav-container">
          <div className="inner-navbar">
            <div className="container">
              <Navbar
                expand="lg"
                expanded={expanded}
                onToggle={(isOpen) => setExpanded(isOpen)}
                className="glass-nav mobile-header"
              >
                {/* Toggle */}
                <Navbar.Toggle aria-controls="glass-nav" />
                {/* Logo */}
                <Navbar.Brand
                  as={NavLink}
                  to="/home"
                  className="brand"
                  onClick={() => setExpanded(false)}
                >
                  <img
                    src="images/logo/logo.png"
                    alt="Spirulina Logo"
                    className="navbar-logo"
                  />
                </Navbar.Brand>
                <div className="last_div">
                  <div
                    className="bell_icon_div d-lg-none d-block"
                    onClick={() => navigate("/notification")}
                  >
                    <FontAwesomeIcon icon={faBell} className="bell_icon" />
                  </div>
                  {/* Mobile Profile */}
                  <div
                    className="nav-profile-1"
                    onClick={() => navigate("/profile")}
                  >
                    <Profile />
                  </div>{" "}
                  <div
                    className="login-div tablet-logout"
                    onClick={() => setShowLogoutConfirm(true)}
                  >

                    Log Out {"   "}     <FontAwesomeIcon icon={faArrowRightFromBracket} />
                  </div>
                </div>
                {/* Collapse */}
                <Navbar.Collapse
                  id="glass-nav"
                  onClick={() => setExpanded(false)}
                >
                  <Nav className=" nav-center">
                    <Nav.Link
                      as={NavLink}
                      to="/home"
                      end
                      onClick={() => setExpanded(false)}
                    >
                      <button className="navbar-button">Homepage</button>
                    </Nav.Link>

                    <Nav.Link
                      as={NavLink}
                      to="/about"
                      onClick={() => setExpanded(false)}
                    >
                      <button className="navbar-button">About Us</button>
                    </Nav.Link>

                    <Nav.Link
                      as={NavLink}
                      to="/products"
                      onClick={() => setExpanded(false)}
                    >
                      <button className="navbar-button">Products</button>
                    </Nav.Link>

                    <Nav.Link
                      as={NavLink}
                      to="/contact"
                      onClick={() => setExpanded(false)}
                    >
                      <button className="navbar-button">Contact Us</button>
                    </Nav.Link>
                  </Nav>

                  {/* Right Section */}
                  <div className="nav-right">
                    <div
                      className="bell_icon_div desckotp-view"
                      onClick={() => navigate("/notification")}
                    >
                      <FontAwesomeIcon icon={faBell} className="bell_icon" />
                    </div>
                    <div className="refer">
                      {/* <div className="lottie_holder">
                        <Fire_Lottie />
                      </div>
                      <div>
                        <div>Refer & Earn More</div>
                        <div></div>
                        <div className="sub">with Exciting Rewards</div>
                        <div className="sub"></div>
                      </div>{" "} */}
                      <div
                        className="login-div mobile-logoout "
                        onClick={() => setShowLogoutConfirm(true)}
                      >

                        Log Out {"    "} <FontAwesomeIcon icon={faArrowRightFromBracket} />
                      </div>
                    </div>

                    <div
                      className="nav-profile-2 navbar-profile"
                      onClick={() => navigate("/profile")}
                    >
                      <Profile />
                    </div>
                    <div
                      className="login-div desk-logout"
                      onClick={() => setShowLogoutConfirm(true)}
                    >

                      Log Out {"   "} <FontAwesomeIcon icon={faArrowRightFromBracket} />
                    </div>
                  </div>
                </Navbar.Collapse>

              </Navbar>
            </div>
          </div>
        </div>
      </header>

      <Modal
        show={showLogoutConfirm}
        onHide={() => setShowLogoutConfirm(false)}
        centered
        backdropClassName="success-backdrop"
        contentClassName="success-modal-content"
      >
        <div className="success-wrapper logout">
          <div className="success-box">
            <div className="contain-wrapper">
              <h4>Confirm Logout!</h4>
              <p>Are you sure you want to logout?</p>
            </div>
            <div className="button-wrapper">
              <WhiteButton
                title={"Confirm"}
                bg="#010E1E"
                color="#f35f37"
                hoverColor="#f35f37"
                hoverBg={"#010E1E"}
                onClick={() => {
                  dispatch(logoutUser());
                  navigate("/");
                }}
              />
            </div>
          </div>
        </div>
      </Modal>

      {/* <Modal
        show={showLogoutConfirm}
        onHide={() => setShowLogoutConfirm(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Logout</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to logout?</Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowLogoutConfirm(false)}
          >
            No
          </Button>

          <Button
            variant="danger"
            onClick={() => {
              dispatch(logoutUser());
              navigate("/");
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal> */}
    </>
  );
}

export default Header;
